// src/components/admin/RemesasManager.jsx
import { useEffect, useState } from "react";
import Button from "./Button";
import RemesasPanel from "./RemesasPanel";
import DevolucionesPanel from "./DevolucionesPanel";
import HistorialPanel from "./HistorialPanel";
import RecibosPanel from "./RecibosPanel";
import MandatosTmpPanel from "./MandatosTmpPanel";
import MandatosDefPanel from "./MandatosDefPanel";
import AddReciboPanel from "./AddReciboPanel";
import { FileText, X } from "lucide-react";
import { defaultPeriodoHoy } from "../Utiles/helpers";

const RemesasManager = () => {
  const [tab, setTab] = useState("remesas");
  const [toast, setToast] = useState();

  const [codigoBuscar, setCodigoBuscar] = useState("");
  const [devolPeriodo, setDevolPeriodo] = useState(defaultPeriodoHoy());
  const [devolFiltro, setDevolFiltro] = useState("PEND");
  const [recibosReloadKey, setRecibosReloadKey] = useState(0);

  useEffect(() => {
    if (tab === "recibos") setRecibosReloadKey((k) => k + 1);
  }, [tab]);

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold mb-4">Gestión Remesas SEPA</h1>

      <div className="flex flex-wrap gap-2 mb-6">
        <Button variant={tab === "remesas" ? "primary" : "ghost"} onClick={() => setTab("remesas")}>Remesas</Button>
        <Button variant={tab === "devoluciones" ? "primary" : "ghost"} onClick={() => setTab("devoluciones")}>Reembolsos</Button>
        <Button variant={tab === "colegiado" ? "primary" : "ghost"} onClick={() => setTab("colegiado")}>Movimientos colegiado</Button>
        <Button variant={tab === "recibos" ? "primary" : "ghost"} onClick={() => setTab("recibos")}>Recibos PENDIENTES</Button>
        <Button variant={tab === "nuevoRecibo" ? "primary" : "ghost"} onClick={() => setTab("nuevoRecibo")}>Añadir recibo</Button>
        <Button variant={tab === "mandatosTmp" ? "primary" : "ghost"} onClick={() => setTab("mandatosTmp")}>Mandatos TMP</Button>
        <Button variant={tab === "mandatos" ? "primary" : "ghost"} onClick={() => setTab("mandatos")}>Mandatos DEF</Button>
      </div>

      {tab === "remesas" && <RemesasPanel toast={toast} setToast={setToast} />}
      {tab === "devoluciones" && (
        <DevolucionesPanel
          devolPeriodo={devolPeriodo}
          setDevolPeriodo={setDevolPeriodo}
          devolFiltro={devolFiltro}
          setDevolFiltro={setDevolFiltro}
          codigoBuscar={codigoBuscar}
          setCodigoBuscar={setCodigoBuscar}
          toast={toast}
          setToast={setToast}
        />
      )}
      {tab === "colegiado" && (
        <HistorialPanel
          codigoBuscar={codigoBuscar}
          setCodigoBuscar={setCodigoBuscar}
          toast={toast}
          setToast={setToast}
        />
      )}
      {tab === "recibos" && <RecibosPanel reloadKey={recibosReloadKey} toast={toast} setToast={setToast} />}
      {tab === "nuevoRecibo" && <AddReciboPanel toast={toast} setToast={setToast} />}
      {tab === "mandatosTmp" && <MandatosTmpPanel toast={toast} setToast={setToast} />}
      {tab === "mandatos" && <MandatosDefPanel toast={toast} setToast={setToast} />}

      {toast && (
        <div className="fixed bottom-4 right-4 bg-gray-900 text-white px-4 py-2 rounded shadow flex items-center gap-2 z-50">
          <FileText size={16} />
          <span className="text-sm">{toast}</span>
          <button onClick={() => setToast(undefined)} className="ml-2">
            <X size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default RemesasManager;